<template>
	<div>
		<div class="first_line">
			<div class="right_warp">
				<el-select class="jul" size="small" filterable v-model="filter.storeName" style="margin-right:3px;"
					placeholder="请选择">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-date-picker value-format="yyyy-MM" size="small" v-model="filter.month" :clearable="false"
					type="month" placeholder="选择月">
				</el-date-picker>
				<el-button class="jul" type="primary" @click="getlist" size="small">筛选</el-button>
				<el-button class="jul" type="primary" @click="exports('0')" size="small">导出</el-button>
			</div>
			<div class="right_warp">
				<span style="margin-right: 20px;margin-left: 20px;">加盟店发型师:</span>
				<div style="display: flex;flex-wrap: wrap;">
					<div v-for=" i in workerList" v-if="i.motor==3" tabindex="item.index" class="divBack">
						<el-tag :closable="jidongShow" @close="deljiDong(i.id,0)"
							@click="check(i.id,i.name,i.telphone) " class=" jidongbtn">{{i.name}}
						</el-tag>
					</div>
				</div>
				<el-button type="text" size="small" class="red" @click="jidongShow=!jidongShow"
					style="margin-left: 20px;">
					移除</el-button>
				<el-button type="text" size="small" @click="firstAddJiDong()" style="margin-left: 20px;">
					添加</el-button>
				<el-button class="jul" type="primary" @click="exports('1')" size="small">导出</el-button>
			</div>
		</div>
		<el-dialog :visible.sync="addWorker" @close="close" width="20%">
			<div style="font-size: 16px; height:auto; margin-bottom:5px;">
				<div>
					<p1>添加机动组成员</p1>
					</br>
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
				</div>
				<div>
					<el-radio-group v-model="radio">
						<el-radio v-for="j in workerList1" v-if="j.status!=8"
							@click.native.prevent="check(j.id,j.name,j.phone)">
							{{j.name}}———{{j.storeName}}
						</el-radio>
					</el-radio-group>
				</div>
				<el-button type="primary" style="margin-left: 40%; margin-top: 15px;"
					@click="saveWorkerStatus(jiDongcheck,3)">确定
				</el-button>
			</div>
		</el-dialog>
		<div>
			<div class="calendar">
				<el-table :data="list" style="width: 100%"
					:header-cell-style="{background:'#F2F2F4', 'text-align':'center'}"
					:cell-style="{'text-align':'center'}">
					<el-table-column prop="name" label="姓名" />
					<el-table-column prop="storeName" label="门店" />
					<el-table-column prop="workDays" label="出勤天数" />
					<el-table-column prop="restDays" label="例休天数" />
					<el-table-column prop="overtimeDays" label="加班天数" />
					<el-table-column prop="applyDays" label="请假天数" />
					<!-- <el-table-column prop="yiqingDays" label="疫情办公"/> -->
					<el-table-column prop="lastTimeAll" label="迟到(分钟)" />
					<el-table-column prop="beforeTimeAll" label="早退(分钟)" />
					<el-table-column prop="absentDays" label="旷工天数" />
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		parseTime,
		url
	} from "../../../utils/index.js"
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		components: {
			ElImageViewer
		},
		data() {
			return {
				url: url(),
				total: 0,
				list: [],
				dates: [],
				filter: {
					month: new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
						.getMonth() + 1) : (new Date().getMonth() + 1)),
					pageNum: 1,
					pageSize: 10,
					name: undefined,
				},
				showViewer: false,
				times: "",
				timeVal: "",
				storeval: [],
				workerList: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
				},
				workerList1: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
					status: "",
				},
				jiDongcheck: undefined,
				tagName: undefined,
				tagPhone: undefined,
				addWorker: false,
				closable: false,
				jidongShow: false,
				statelist: [{
					value: undefined,
					label: "全部门店"
				}],
			};
		},
		created(){
			this.getstorelist();
			this.getWorkerList()
		},
		mounted() {
			this.getlist();
		},
		methods: {
			//考情列表导出 0不含加盟店发型师  1只含加盟店发型师
			exports(type) {
				var urls = this.url + "dcheckuser/exporMonthScheduling?month=" + this.filter.month + "&type=" + type;
				if (this.filter.storeName) urls += "&storeName=" + this.filter.storeName;
				window.location.assign(urls)
			},
			getlist() {
				this.$http.post("dcheckuser/findMonthScheduling", JSON.stringify(this.filter)).then((res) => {
					if (res.body.code == 200) {
						this.list = res.body.data
						this.total = res.body.total
					}
				})
			},
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					if (res.body.code == 200) {
						res.body.data.forEach(ele => {
							if (ele.businessType == 0) this.statelist.push({
								value: ele.title,
								label: ele.title
							})
						});
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			saveWorkerStatus(id, motor) {
				var arr = {
					id: id,
					motor: motor
				}
				this.$http.post("dWorker/saveOrUpdate", JSON.stringify(arr)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("更改成功")
						this.addWorker = false
						this.getWorkerList()
					}
				})
				this.addWorker = false
			},
			check(id, name, telphone) {
				this.jiDongcheck = id
				this.tagName = name
				this.tagPhone = telphone
			},
			getWorkerList1(name) {
				this.$http.get("dWorker/queryAll" + "?name=" + name).then(res => {
					this.workerList1 = res.body.data;
				})
			},
			deljiDong(id, motor) {
				this.$confirm('移除该发型师, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var a = {
						id: id,
						motor: 0
					}
					this.$http.post("dWorker/saveOrUpdate", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("移除成功")
						} else {
							this.$message.success("移除失败")
						}
						this.getWorkerList()
					})
				})
			},
			firstAddJiDong() {
				this.workerList1 = {}
				this.addWorker = true
			},
			getWorkerList() {
				this.$http.get("dWorker/query?filterOut=1").then(res => {
					this.workerList = res.body.data;
					this.worker = res.body.data;
				})
			},
			close() {
				this.selectObj.outWorker = undefined;
				this.outRoster = undefined;
				this.selectObj.outStorename = undefined;
				this.storeRosters = [];
			},
			// onPreview() {
			//  this.showViewer = true
			// },
			// closeViewer() {
			//  this.showViewer = false
			// },
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getlist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getlist()
			},
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.pagechange {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>